import { Link } from "react-router-dom";
import type { Film } from "@/types/film";

interface FilmCardProps {
  film: Film;
}

export default function FilmCard({ film }: FilmCardProps) {
  return (
    <Link
      to={`/detail/${film.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={film.cover}
          alt={`${film.title}封面`}
          title={`${film.title} - 伦理视频`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-primary-950/70 to-transparent" />
        <span className="absolute left-2.5 top-2.5 flex items-center gap-1 rounded-full bg-accent-500 px-2 py-0.5 text-xs font-medium text-background-50">
          <i className="ri-star-fill text-[10px]" />
          {film.rating.toFixed(1)}
        </span>
        <span className="absolute right-2.5 top-2.5 rounded-full bg-primary-950/70 px-2 py-0.5 text-[11px] text-background-50 backdrop-blur-sm">
          {film.kind === "movie" ? "电影" : `${film.episodes} 集`}
        </span>
        <span className="absolute bottom-2.5 left-2.5 text-[11px] text-background-100">
          {film.year} · {film.region}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3.5 md:p-4">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600 clamp-2">
          {film.title}
        </h3>
        <p className="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-foreground-500">
          {film.genres.slice(0, 2).map((genre) => (
            <span key={genre} className="rounded-sm bg-secondary-100 px-1.5 py-0.5 text-secondary-900">
              {genre}
            </span>
          ))}
          <span className="text-foreground-400">{film.duration}</span>
        </p>
        <p className="mt-2 text-xs leading-relaxed text-foreground-600 clamp-2">{film.summary}</p>
      </div>
    </Link>
  );
}